import { useState } from "react";

export const AdminLogin = ({ api, onLogin }) => {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!password) return;
    setBusy(true);
    setError("");
    try {
      const res = await fetch(`${api}/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ password }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(typeof data.detail === "string" ? data.detail : "Sign-in failed");
      localStorage.setItem("vale_admin_token", data.token);
      onLogin(data.token);
    } catch (err) {
      setError(err.message || "Sign-in failed");
    }
    setBusy(false);
  };

  return (
    <div className="min-h-screen bg-[#050505] text-white flex items-center justify-center px-6" data-testid="admin-login">
      <form onSubmit={submit} className="rounded-2xl border border-[#2E2E2E] bg-[#111111] p-8 w-full max-w-sm space-y-5">
        <p className="text-base font-semibold text-[#FF5C5C]">Admin sign-in</p>
        <h1 className="font-display text-2xl text-white">Admin console</h1>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          data-testid="admin-password-input"
          className="rounded-xl bg-[#050505] border border-[#2E2E2E] px-4 py-3 text-base font-medium text-white placeholder:text-[#D6D6D6] outline-none focus:border-[#FF5C5C] w-full"
        />
        {error && <p className="text-base font-semibold text-[#FF5C5C]" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={busy || !password} data-testid="admin-login-button"
          className="rounded-xl bg-white text-black font-semibold text-base px-6 py-3 hover:bg-[#D6D6D6] disabled:opacity-40 transition-colors duration-150 w-full">
          {busy ? "Checking..." : "Sign in"}
        </button>
      </form>
    </div>
  );
};
